import { NotificacionExtendida } from '@components/general/Alertas/Alertas';
import UserContext from '@context/User/UserContext';
import useSignaturePad from '@customHooks/useSignaturePad';
import { faArrowLeft, faArrowRight, faCheck, faFileSignature, faFileUpload, faSearch, faSpinner, faUndo, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDatosUsuario, getUsuarioByFolio, renovarLicencia } from '@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Animated } from 'react-animated-css';
import { Button, Col, Container, FloatingLabel, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import ReactSignatureCanvas from 'react-signature-canvas';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import getFilledPdfBytes from './getFilledPdfBytes';
import getUnixTimestamp from '@helpers/dates/getUnixTimestamp/getUnixTimestamp';
import httpFormDataRequest from '@helpers/httpRequests/httpFormDataRequest';
import endpointsPaths from '@helpers/httpRequests/endpointsPaths/endpointsPaths';
import httpRequestsPaths from '@helpers/httpRequestsPaths/httpRequestsPaths';
import { procesarIdentificaciones, retrievePaymentIntent, validarDebitoCredito } from '@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos';
import dashboardRoutesPaths from '@helpers/dashboardRoutesPaths/dashboardRoutesPaths';
import FormularioNuevaCompra from '@helpers/paymentIntent/FormularioNuevaCompra';
import { enviarComprobanteRenovacion } from '@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers';
import numberCommaSeparator from '@helpers/formateoPrecios/numberCommaSeparator';
import { NotificationManager } from 'react-notifications';
import { getUltimoFolioContrato, subirFotosSai } from '@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI';
import getPdfScreenshot from '@helpers/pdf/getPdfScreenshot/getPdfScreenshot';

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

const FormularioSuscripcion = ({history}) => {


    const signaturePad = useRef();

    const { showSignaturePad, signed, handleInitSignaturePadButton, resetSignaturePad, getImageFromSignaturePad, isEmpty, blockSignaturePad, unlockSignaturePad } = useSignaturePad();

    const { contextValue, setContextValue } = useContext(UserContext);

    const { usuarioLogeado = {}, renovacion = {} } = contextValue;

    const {folioContrato = ''} = usuarioLogeado;

    const [datosUsuario, setDatosUsuario] = useState(false);

    const [loading, setLoading] = useState(false);

    const [formValues, setFormValues] = useState({
        firma: "",
        nombreCompleto: '',
        apellidos: '',
        folioContrato: '',
        dia: "",
        mes: "",
        year: "",
        ciudad: "León, Gto.",
        numeroTarjeta: "",
        clabe: "",
        telefono: "",
        ineFrontal: '',
        ineTrasera: '',
        contratoBase64: '',
        domiBase64: '',
        correoCliente: '',
    })

    const [signContrato, setSignContrato] = useState(false);

    const [showDomiciliacion, setShowDomiciliacion] = useState(false);

    const [ineFrontal, setIneFrontal] = useState(false);

    const [ineTrasera, setIneTrasera] = useState(false);

    const [loader, setLoader] = useState(false);

    const [makePayment, setMakePayment] = useState(false);

    const [key, setKey] = useState("edoCuenta");
    


    const handleResetClick = () => {
        resetSignaturePad(signaturePad);
    };

    const checkEmptySignature = () => {
        return isEmpty(signaturePad);
    };


    const particlesOptions = {
        fpsLimit: 60,
        particles: {
            number: {
                value: 100,
                density: {
                    enable: true,
                },
            },
            color: {
                value: ["#ffcc00", "#ffffff", "#ff9900"],
            },
            opacity: {
                value: { min: 0.1, max: 0.6 },
            },
            size: {
                value: { min: 1, max: 3 },
            },
            move: {
                enable: true,
                speed: 4,
                random: false,
            },
        },
        interactivity: {
            detectsOn: "window",
            events: {
                onClick: {
                    enable: true,
                    mode: "push",
                },
                resize: true,
            },
        },
        background: {
            image: "url('https://globalclickmexico.com/img/loginNuevo.webp')",
            position: "50% 50%",
            size: "cover",
            repeat: "no-repeat",
        },
    };

    const particlesInit = useCallback(async (engine) => {
        await loadFull(engine);
    }, []);

    const handleOnChange = ({ currentTarget }) => {
        const { value, name } = currentTarget;

        setFormValues({
            ...formValues,
            [name]: value,
        })
    }

    const handleDatos = async () => {
        try {
            const data = await getUsuarioByFolio(formValues.folioContrato, 1)

            if (!data){
            NotificacionExtendida("error", `Folio incorrecto o no existe, inténtalo de nuevo`);
            }

            //TODO: Al recuperar la data del usuario almacenarle en el local storage del navegador para poder usarle en caso de que se cierre el navegador o la pestaña.
            setFormValues({
                ...formValues,
                nombreCompleto: data.nombreCompleto,
                apellidos: data.apellidos,
                correoCliente: data.correo,
                idPersona: data.idPersona,
                idCredencial: data.idCredencial,
                rol: data.rol,
                usuarioTitular: data.usuarioTitular
            })

            setDatosUsuario(true);
        } catch (error) {
            console.log(error);
            NotificacionExtendida("error", `Error al recuperar información, intentalo de nuevo más tarde`);
        }
    }

    const createPdf = async (dataContrato) => {
        try {
            let url = `${window.location.origin}/assets/templates/CONTRATO_SUSCRIPCION_RENOVACION.pdf`;

            const data = await fetch(url);

            const pdfTemplateBytes = await data.arrayBuffer();

            const filledPdfBytes = await getFilledPdfBytes(
                pdfTemplateBytes,
                dataContrato
            );

            saveByteArray(`Contrato descargado`, filledPdfBytes, 'contrato');

            const pdfScreenshotBytes = await getPdfScreenshot({ filledPdfBytes });

            setFormValues({
                ...formValues,
                contratoBase64: pdfScreenshotBytes
            })

            return pdfScreenshotBytes;

        } catch (error) {
            console.log(error);
        }
    };

    const createDomiciliacion = async (dataDomiciliacion) => {
        try {
            let url = `${window.location.origin}/assets/templates/HOJA_DOMICILIACION_2025.pdf`;

            const data = await fetch(url);

            const pdfTemplateBytes = await data.arrayBuffer();


            const filledPdfBytes = await getFilledPdfBytes(
                pdfTemplateBytes,
                dataDomiciliacion
            );


            await saveByteArray(`Domiciliacion_${formValues.folioContrato}`, filledPdfBytes, 'domiciliacion');

            const pdfScreenshotBytes = await getPdfScreenshot({ filledPdfBytes });


            setFormValues({
                ...formValues,
                domiBase64: pdfScreenshotBytes
            })


            return pdfScreenshotBytes;
        } catch (error) {
            console.log(error);
        }
    };

    //Funcion para descargar el pdf sin la libreria
    const saveByteArray = async (reportName, byte, caso) => {
        var blob = new Blob([byte], { type: "application/pdf" });

        var link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);

        const formData = new FormData();
        switch (caso) {
            case 'contrato':
                
                
                //FETCH PARA MANDAR LOS DATOS DEL ARCHIVO AL SERVIDOR
                
                formData.append("archivoAdjunto", blob);

                await httpFormDataRequest({
                    url: `${endpointsPaths.pagos}/${httpRequestsPaths.pagos.notificarSuscripcion}?folioContrato=${formValues.folioContrato}&correo=${formValues.correoCliente}&nombreCompleto=${formValues.nombreCompleto}&apellidos=${formValues.apellidos}`,
                    body: formData,
                });
                // link.download = fileName;

                // link.click();
                break;

            case 'domiciliacion':
                
                //FETCH PARA MANDAR LOS DATOS DEL ARCHIVO AL SERVIDOR

                formData.append("archivoAdjunto", blob);

                await httpFormDataRequest({
                    url: `${endpointsPaths.pagos}/${httpRequestsPaths.pagos.saveDomiciliacion}?folioContrato=${formValues.folioContrato}&correo=${formValues.correoCliente}&nombreCompleto=${formValues.nombreCompleto}&apellidos=${formValues.apellidos}`,
                    body: formData,
                });

                break;
            default:
                break;
        }

        NotificacionExtendida("success", `${caso} generado con éxito`);
        
    };

    

    const fileReader = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const base64String = e.target.result;
                resolve(base64String); // <-- esto sí devuelve el valor al await
            };

            reader.onerror = (err) => reject(err);

            reader.readAsDataURL(file);
        });
    };


    const handleIdentificacion = async(event) => {
        const { name, value } = event.target;

        let file = event.target.files[0];

        console.log(file);

        let imagen= '';

        switch (name) {
            case 'ineFrontal':
                setIneFrontal(true);
                imagen = await fileReader(file)
                break;

            case 'ineTrasera':
                setIneTrasera(true);
                imagen = await fileReader(file)

                break;


            default:
                break;
        }

        setFormValues({
            ...formValues,
            [name]: imagen
        })


    }

    const handleInfoPago = async() =>{

        const bin = formValues.numeroTarjeta.substring(0,6);

        const validacion = await validarDebitoCredito(bin)

        console.log(validacion);

        if(validacion.Type !== 'CREDIT'){
            NotificacionExtendida('error', 'Por favor, ingresa una tarjeta de crédito válida');
            return;
        }

        setFormValues({
            ...formValues,
            banco: validacion.Issuer
        })
        
        if(formValues.numeroTarjeta === '' && formValues.clabe === '' && formValues.numeroTarjeta === '') {
            NotificacionExtendida('warning', 'Llena todos los campos');
            return;
        }

        setShowDomiciliacion(false);
        setSignContrato(true);
    }


    const getArrayJsonCargaImagenes = ({idRegion, folioContrato, imagesData }) => {
	return new Promise(async (resolve, reject) => {
		try {
            
            //TODO: SE TIENE QUE AGREGAR EL OBJETO PARA EL CONTRATO Y LA DOMICILIACION Y QUITAR LA TC
			let arrayJSONFotos = [
				{
					idRegion,
					folioContrato,
					nombreFoto: "03_ife_frente",
					fotoBase64: imagesData.caraFrontalIne,
				},
				{
					idRegion,
					folioContrato,
					nombreFoto: "04_ife_atras",
					fotoBase64: imagesData.caraPosteriorIne,
				},
                {
					idRegion,
					folioContrato,
					nombreFoto: "02_contrato",
					fotoBase64: imagesData.contrato,
				},
                {
					idRegion,
					folioContrato,
					nombreFoto: "05_domiciliacion",
					fotoBase64: imagesData.domiciliacion,
				},
			];

			resolve(arrayJSONFotos);
		} catch (error) {
			console.log(error);

			reject(error);
		}
	});
};


    const handleSuscripcion = async()=> {
        try {
            setLoader(true);

            const fecha = getUnixTimestamp();

            const fechaFinalizacionAux = new Date(fecha * 1000);

            const anio = fechaFinalizacionAux.getFullYear();

            const mes = months[fechaFinalizacionAux.getMonth()];

            const dia = fechaFinalizacionAux.getDate();

            //Se comienza a procesar la suscripcion

            const domiBase64 = await createDomiciliacion({
                dia: dia.toString(),
                mes: mes.toString(),
                year: anio.toString(),
                ciudad: formValues.ciudad,
                nombre_cliente: `${formValues.nombreCompleto} ${formValues.apellidos}`,
                firma_cliente: formValues.firma,
                numeroTarjeta: formValues.numeroTarjeta,
                clabe: formValues.clabe,
                numeroTelefono: formValues.numeroTelefono,
                bank: formValues.banco
            })
            const data ={
                ineFrontal: formValues.ineFrontal,
                ineTrasera: formValues.ineTrasera,
                folioContrato: formValues.folioContrato
            }

            await procesarIdentificaciones(data);

            const contratoBase64 = await createPdf({
                dia: dia.toString(),
                mes: mes.toString(),
                year: anio.toString(),
                ciudad: formValues.ciudad,
                nombre_cliente: `${formValues.nombreCompleto} ${formValues.apellidos}`,
                firma_cliente: formValues.firma,
            });
            setLoader(false)

            //recuperar el ultimo folio del cliente para subir su documentacion a ese folio

            const {data: datosFolio} = await getUltimoFolioContrato({
                idRegion: 1,
                folioContrato: formValues.folioContrato,
            })

            const arrayJSONFotos = await getArrayJsonCargaImagenes({
                idRegion: 1,
                folioContrato: datosFolio.folioCompuesto,
                imagesData: {
                    caraFrontalIne: formValues.ineFrontal,
                    caraPosteriorIne: formValues.ineTrasera,
                    contrato: contratoBase64,
                    domiciliacion: domiBase64
                },
            });

            await subirFotosSai(arrayJSONFotos);

            //TODO: Al finalizar todo borrar la info del localstorage para que se vuelva a comenzar con todo el proceso de renovacion en caso de ser necesario.
        
            
            //Se redirige al usuario al login a iniciar sesion.
            history.replace(dashboardRoutesPaths.login);


        } catch (error) {

            setLoader(false);

            console.log("Error al procesar la suscripción: ", error)
            NotificacionExtendida('error', "Error al procesar la suscripción");
        }
    }

    const changeFolio = () =>{
        setDatosUsuario(false);
        setFormValues({
            ...formValues,
            firma: "",
            nombreCompleto: '',
            apellidos: '',
            folioContrato: '',
            dia: "",
            mes: "",
            year: "",
            ciudad: "León, Gto.",
            numeroTarjeta: "",
            clabe: "",
            telefono: "",
            ineFrontal: '',
            ineTrasera: ''
        })
    }

    const enviarComprobante = (datosComprobante, formValues, datosCompra, paymentMethod, paymentIntent) => {
            return new Promise(async (resolve, reject) => {
                try {
    
                    const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
    
                    const { metodoPago, precios } = datosCompra;
    
                    const {
                        card: { last4 },
                    } = paymentMethod;
    
                    const {
                        id: paymentIntentId,
                        // amount: montoCobro,
                        payment_method_options: { card },
                    } = paymentIntent;
    
                    const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;
    
                    const replacements = {
                        folioContrato,
                        titular,
                        numeroTarjeta: `Tarjeta con terminación ${last4}`,
                        metodoPago: "De contado",
                        description: `Renovación de Licencia Click+ Premium - Folio ${folioContrato}`,
                        paymentIntentId,
                        correo,
                        montoCobro: numberCommaSeparator(datosComprobante.montoCobro / 100),
                        costoBase:numberCommaSeparator(datosComprobante.montoCobro / 100),
                        
                    };
    
                    await enviarComprobanteRenovacion(replacements);
    
                    resolve();
                } catch (error) {
                    console.log("Error al enviar el comprobante de compra: ", error);
    
                    reject(error);
                }
            });
        };

    

    const consultarPaymentIntent = async () => {
                try {
                    setLoading(true);
                    const { paymentIntent } = await retrievePaymentIntent(renovacion.stripeSession.payment_intent);
                    console.log(paymentIntent)
                    if (paymentIntent.status === "succeeded") {
        
                        setKey('dashboard');
        
                        setContextValue({
                            ...contextValue,
                            renovacion: {
                                ...contextValue.renovacion,
                                pagoIniciado: false,
                                pagoFinalizado: true
                            }
                        });


                        // NotificationManager.success('¡Pago de renovación verificado!');
                    }
                } catch (error) {
                    setLoading(false);

                    console.log("errpr al consultar el payment intent: ", error);
                }
            };


            const procesarRenovacion = async () => {
                    try {
                        const { stripeSession } = renovacion;
            
                        const { amount_total, payment_intent: paymentIntentId, metadata } = stripeSession;
            
                        const { paymentIntent, paymentMethod } = await retrievePaymentIntent(paymentIntentId);
            
                        const { id: folioPago, amount } = paymentIntent;
            
                        const {
                            card: { last4, funding },
                        } = paymentMethod;

                        //TODO REVISAR QUE SE ENVIAN TODOS LOS DATOS
            
                        const datosRenovacion = {
                            folioContrato: formValues.folioContrato,
                            pagoDeContado: true,
                            costoTotal: amount / 100,
                            amortizacionesTotales: 1,
                            montoPagado: amount / 100,
                            montoQuincenal: amount / 100,
                            metodoPago: 'contado',
                            tipoTarjeta: funding,
                            referenciaPago: paymentIntentId,
                        };

                        // console.log({
                        //     folioContrato: formValues.folioContrato,
                        //     pagoDeContado: true,
                        //     costoTotal: amount / 100,
                        //     amortizacionesTotales: 1,
                        //     montoPagado: amount / 100,
                        //     montoQuincenal: amount / 100,
                        //     metodoPago: 'contado',
                        //     tipoTarjeta: funding,
                        //     referenciaPago: paymentIntentId,
                        //     folioContrato: metadata.folioContrato,
                        //     datosRenovacion,
                        //     idPersona: formValues.idPersona,
                        //     idCredencial: formValues.idCredencial,
                        //     idRegion: 1,
                        //     folioRenovacion: formValues.folioRenovacion
                        // })

                        await renovarLicencia({
                            folioContrato: metadata.folioContrato,
                            datosRenovacion,
                            idPersona: formValues.idPersona,
                            idCredencial: formValues.idCredencial,
                            idRegion: 1,
                            folioRenovacion: formValues.folioRenovacion
                        });
            
                        const { data: datosUsuario } = await getDatosUsuario({
                            tipoUsuario: formValues.rol,
                            idCredencial: formValues.idCredencial,
                            usuarioTitular: formValues.usuarioTitular,
                        });
            
                        const [datosUsuarioActualizados] = datosUsuario;
            
                        setContextValue({
                            ...contextValue,
                            usuarioLogeado: datosUsuarioActualizados,
                            renovacion: undefined,
                        });


                        
                        await enviarComprobante(
                            {
                                titular: `${formValues.nombreCompleto} ${formValues.apellidos}`,
                                paymentIntentId: folioPago,
                                folioContrato: metadata.folioContrato,
                                montoCobro: amount,
                                numeroTarjeta: `Tarjeta con terminación ${last4}`,
                                description: `Renovación de Licencia Click+ - Folio ${folioContrato}`,
                                correo: formValues.correo,
                            },
                            {
                                folioContrato: metadata.folioContrato,
                                nombre: formValues.nombreCompleto,
                                apellidoPaterno: formValues.apellidos.split(" ")[0],
                                apellidoMaterno: formValues.apellidos.split(" ")[0],
                                correo: formValues.correo
                            },
                            { metodoPago: renovacion.metodoPago, precios: renovacion.precios },
                            paymentMethod,
                            paymentIntent
                        );

                        //TODO GENERAR LA DOCUMENTACION A PARTIR DE AQUI Y REDIRECCIONAR UNA VEZ ESTE GENERADA

                        setLoading(false);

                        setMakePayment(false);

                        // setShowDomiciliacion(true);
            

                        NotificationManager.success("¡Renovación efectuada con éxito!");

                        history.replace(dashboardRoutesPaths.login);

            
                        // setTimeout(() => window.location.reload(), 1500);
                    } catch (error) {
                        console.log("Error al renovar la licencia: ", error);
                    }
                };


    //TODO: Refactorizar esta funcion para recuperar directamente del localstorage del navegador la info del usuario en caso de estar guardada y validar si ya se realizó el pago o no de la suscripcion para solo generar la documentación.

    //VALIDAR SI ESTÁ LOGEADO EL USUARIO Y OBTENER SUS DATOS DEL CONTEXT

    //SI NO ESTÁ LOGEADO HAY QUE OBTENER SUS DATOS MEDIANTE API USANDO SU FOLIO DE CONTRATO

    // useEffect(() => {
    //     if (Object.keys(usuarioLogeado).length > 0) {
    //         setDatosUsuario(true)
    //         console.log(usuarioLogeado)
    //         setFormValues({
    //             ...formValues,
    //             nombreCompleto: usuarioLogeado.nombreCompleto,
    //             apellidos: usuarioLogeado.apellidos,
    //             folioContrato: usuarioLogeado.folioContrato,
    //             correoCliente: usuarioLogeado.correo,
    //             idPersona: usuarioLogeado.idPersona,
    //             idCredencial: usuarioLogeado.idCredencial,
    //             rol: usuarioLogeado.rol,
    //             usuarioTitular: usuarioLogeado.usuarioTitular
    //         })
    //     }


    // }, [])

    useEffect(() => {
        if (signed) {
            let emptyCanvas = checkEmptySignature();

            if (!emptyCanvas) {
                setFormValues({
                    ...formValues,
                    firma: signaturePad?.current?.getTrimmedCanvas().toDataURL(),
                });
            }

            blockSignaturePad(signaturePad);
        } else {
            setFormValues({
                ...formValues,
                firma: "",
            });

            unlockSignaturePad(signaturePad);
        }
    }, [signed]);


    useEffect(() => {
            if (renovacion) {
                console.log("RENOVACION")
                    if (renovacion.pagoIniciado && renovacion.renovacionKueski === false) {
                        console.log('ENTRA EN EL IF DE LA RENOVACION')
                        consultarPaymentIntent();
                    }else if(renovacion.pagoFinalizado && renovacion.renovacionKueski === false){
                        procesarRenovacion();
                    }
                }
        }, [renovacion])



    return (
        <>
            <Particles options={particlesOptions} init={particlesInit} id="tsparticles" />


            <Animated animationIn="fadeIn" isVisible={true} className="form-suscripcion">
                <div id="particles" className="h-100">
                    <Container className="d-flex h-100 justify-content-center flex-column align-items-center">
                        <Row className='justify-content-center' style={{ zIndex: "100", width: "100%" }}>
                            <Col className="col-12 col-lg-6 p-3 p-lg-5 mt-5 mt-lg-0" style={{ backgroundColor: "#f2f2f2", borderRadius: "15px" }}>

                                {loading ? (
                                    <div className='p-5 text-center'>
                                        <h2 className='mb-3'>Validando compra...</h2>
                                        <Spinner animation='border' />
                                        
                                        <p className='mt-3'>Por favor, no cierres esta ventana, estamos procesando tu compra.</p>
                                    </div>
                                ): (
                                    <>
                                        {makePayment ? (
                                            <Row>
                                                <Col className="col-12 text-end">
                                                        <Button className='btn btn-warning' onClick={() => setMakePayment(false)}><FontAwesomeIcon icon={faArrowLeft} /> Regresar</Button>
                                                    </Col>
                                                <Col>
                                                    <FormularioNuevaCompra
                                                        imgProducto={require("@assets/images/click.png")}
                                                        precioProducto={99 * 100}
                                                        precioProductoUSD={99 * 100}
                                                        nombreProducto={"Renovación de licencia Click+ | Suscripción quincenal"}
                                                        compraExterna={false}
                                                        compraLectura={false}
                                                        compraKueski={false}
                                                        folioContrato={formValues.folioContrato}
                                                        // codigoAplicado={codigoAplicado}
                                                        // precios={precios}
                                                        // valueRadioButton={valueRadioButton}
                                                        msiEnabled={false}
                                                        esRenovacion={true}
                                                        successUrl={`${dashboardRoutesPaths.pagos.renovacion.renovacionLicenciaFormulario}`}
                                                    />
                                                </Col>
                                            </Row>
                                        ) : null}
                                        <Form onSubmit={(e) => e.preventDefault()} className='text-center'>

                                            {(!signContrato && !showDomiciliacion && !makePayment) ? (
                                                <div>
                                                    {datosUsuario && (
                                                        <div className='d-flex flex-row align-items-center justify-content-between mb-5 mb-lg-0'>
                                                            <h2 className='mb-4 text-center text-lg-start'>Valida tu información</h2>
                                                            <Button onClick={changeFolio} className="btn btn-danger btn-sm">No es mi folio</Button>
                                                        </div>
                                                    )}



                                                    <Row>
                                                        <h4 className="text-center text-lg-start mb-3">Información de licencia</h4>

                                                        <Col className='text-center text-lg-start col-12'>
                                                            {datosUsuario ? (
                                                                <p>Folio de contrato: <b>{formValues.folioContrato}</b></p>
                                                            ) : (
                                                                <>
                                                                    <p><small>Por favor, ingresa tu folio de contrato para obtener la información de tu licencia.</small></p>
                                                                    <InputGroup className="mb-3 w-100 w-lg-50">
                                                                        <Form.Control onChange={handleOnChange} name="folioContrato" value={formValues.folioContrato} disabled={datosUsuario} aria-label="First name" placeholder='Folio de contrato' />
                                                                        {!datosUsuario && (
                                                                            <InputGroup.Text><Button type={'button'} onClick={handleDatos}><FontAwesomeIcon icon={faSearch} /></Button></InputGroup.Text>
                                                                        )}
                                                                    </InputGroup>
                                                                </>
                                                            )}

                                                        </Col>

                                                        {datosUsuario ? (
                                                            <h4 className="text-center text-lg-start mb-3">Información personal</h4>
                                                        ): null}
                                                        <Col className="mt-4">
                                                            {datosUsuario ? (
                                                                <p>Nombre: <b>{formValues.nombreCompleto}</b></p>

                                                            ) : null}

                                                        </Col>
                                                        <Col className="mt-4">

                                                            {datosUsuario ? (
                                                                <p>Apellidos: <b>{formValues.apellidos}</b></p>
                                                            ) : null}

                                                        </Col>

                                                        <Col className='col-12 mt-5'>
                                                            <p className='text-warning' style={{ fontWeight: 'bold' }}>Esta información será mostrada en tu contrato de renovación una vez que finalices el proceso</p>

                                                            <p className='text-warning' style={{ fontWeight: 'bold' }}>A continuación recopilaremos la información de pago.</p>
                                                        </Col>
                                                    </Row>

                                                    {datosUsuario ? (
                                                        <Button className="btn btn-success mt-5" onClick={() => setMakePayment(true)}>Siguiente <FontAwesomeIcon icon={faArrowRight} /></Button>
                                                    ) : null}

                                                </div>
                                            ) : null}


                                            

{/* 

                                            {showDomiciliacion ? (

                                                <>
                                                    <Row className="justify-content-between flex flex-row align-items-center mt-5 mt-lg-0 mb-5">
                                                        <Col className="col-6 col-lg-auto">
                                                            <h2>Información de pago</h2>
                                                        </Col>

                                                        <Col className="col-auto ">
                                                            <Button className='btn btn-warning' onClick={() => setShowDomiciliacion(false)}><FontAwesomeIcon icon={faArrowLeft} /> Regresar</Button>
                                                        </Col>
                                                    </Row>


                                                    <Row>

                                                        <h5>La siguiente información es unicamente para configurar su plan de renovación, más adelante se realizará el pago para iniciar su suscripción.</h5>

                                                        <Col className='col-12 mt-3'>
                                                            <FloatingLabel
                                                                controlId="floatingInput"
                                                                label="Número de tarjeta (Tarjeta de crédito)"
                                                                className="mb-3"
                                                                required
                                                            >
                                                                <Form.Control maxLength="16" name="numeroTarjeta" onChange={handleOnChange} type="tel" placeholder="Tarjeta de débito" />
                                                            </FloatingLabel>

                                                            <FloatingLabel
                                                                controlId="floatingInput"
                                                                label="Clabe interbancaria (CLABE 18 dígitos)"
                                                                className="mb-3"
                                                                required
                                                            >
                                                                <Form.Control maxLength="18" name="clabe" onChange={handleOnChange} type="tel" placeholder="18 dígitos" />
                                                            </FloatingLabel>

                                                            <FloatingLabel
                                                                controlId="floatingInput"
                                                                label="Número de teléfono"
                                                                className="mb-3"
                                                                required
                                                            >
                                                                <Form.Control maxLength="10" name="numeroTelefono" onChange={handleOnChange} type="tel" placeholder="123 456 78 90" />
                                                            </FloatingLabel>

                                                            <FloatingLabel
                                                                controlId="floatingInput"
                                                                label="Correo electrónico"
                                                                className="mb-3"
                                                                required
                                                            >
                                                                <Form.Control name="correoCliente" onChange={handleOnChange} type="email" placeholder="Correo electrónico" />
                                                            </FloatingLabel>

                                                            <p className='text-center'>Tu información de pago se maneja de forma segura y se procesa de forma cifrada.</p>


                                                            <Col className="mt-3">
                                                                <Button className='btn btn-success' onClick={handleInfoPago}>Siguiente</Button>
                                                            </Col>
                                                        </Col>
                                                    </Row>
                                                </>

                                            ) : null} */}


                                            {/* {signContrato ? (
                                                <>
                                                    <Row className="justify-content-between flex flex-row align-items-center mt-3 mt-lg-0 mb-2">
                                                        <Col className="col-6 col-lg-auto">
                                                            <h2>Firma de autorización</h2>
                                                        </Col>

                                                        <Col className="col-auto ">
                                                            <Button className='btn btn-warning' onClick={() => {
                                                                setSignContrato(false)
                                                                setShowDomiciliacion(true)
                                                            }}><FontAwesomeIcon icon={faArrowLeft} /> Regresar</Button>
                                                        </Col>
                                                    </Row>

                                                    <Row className='justify-content-between flex flex-row align-items-center mt-2 mt-lg-0'>
                                                        <Col className="col-12 my-3">
                                                            <Row>
                                                                <Col className='col-12 col-lg-6'>
                                                                    <Form.Group controlId="formFile" className="mb-3">
                                                                        <Form.Label className={`${ineFrontal ? "text-success" : "text-danger"}`}><FontAwesomeIcon icon={faFileUpload} color="gray" /> INE (cara frontal) </Form.Label>
                                                                        <Form.Control onChange={handleIdentificacion} type="file" name="ineFrontal" />
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col className='col-12 col-lg-6'>
                                                                    <Form.Group controlId="formFile" className="mb-3">
                                                                        <Form.Label className={`${ineTrasera ? "text-success" : "text-danger"}`}><FontAwesomeIcon icon={faFileUpload} color="gray" /> INE (cara trasera) </Form.Label>
                                                                        <Form.Control type="file" onChange={handleIdentificacion} name="ineTrasera" />
                                                                    </Form.Group>
                                                                </Col>
                                                                <p><small>Capture únicamente las caras de su identificación</small></p>
                                                            </Row>
                                                        </Col>
                                                        <Col className='col-12 mt-3'>
                                                            {!signed ? (
                                                                <p><small>Una vez que firme nos dará su autorización para ralizar el cobro de $99.00mxn quincenales.</small></p>
                                                            ) : null}
                                                            <div className={`my-2 signature-canvas ${!showSignaturePad ? "signature-canvas-flex" : ""}`}>
                                                                {!showSignaturePad ? (
                                                                    <Button className="mb-3" id="firmarContrato" variant="primary" onClick={handleInitSignaturePadButton}>
                                                                        <FontAwesomeIcon icon={faFileSignature} /> Firmar contrato
                                                                    </Button>
                                                                ) : (
                                                                    // signed ? (
                                                                    //    <p><small><b>¡Gracias! Se le enviará una copia de su contrato a su correo electrónico registrado</b></small></p> 
                                                                    // ): (
                                                                    //     <ReactSignatureCanvas
                                                                    //         canvasProps={{
                                                                    //             className: `signature-pad ${signed ? "signed-pad" : "signing-pad"}`,
                                                                    //         }}
                                                                    //         clearOnResize={true}
                                                                    //         penColor="Blue"
                                                                    //         ref={signaturePad}
                                                                    //     />
                                                                    // )
                                                                    <ReactSignatureCanvas
                                                                            canvasProps={{
                                                                                className: `signature-pad ${signed ? "signed-pad" : "signing-pad"}`,
                                                                            }}
                                                                            clearOnResize={true}
                                                                            penColor="Blue"
                                                                            ref={signaturePad}
                                                                        />
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>



                                                    <Row>
                                                        <Col className="col-12 col-lg-6">
                                                            <Form.Group>
                                                                <div className="d-grid gap-2 mb-3">
                                                                    <Button className="btn-block" variant="primary" disabled={!showSignaturePad} onClick={handleResetClick}>
                                                                        <FontAwesomeIcon icon={faUndo} /> Volver a firmar
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>

                                                            <Form.Group>
                                                                <div className="d-grid gap-2 mb-3">
                                                                    <Button className="btn-block" variant="success" disabled={!showSignaturePad} onClick={getImageFromSignaturePad}>
                                                                        <FontAwesomeIcon icon={faCheck} /> Terminar de firmar
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col className="col-12 col-lg-6">
                                                            <Form.Group>
                                                                <div className="d-grid gap-2 mb-3">
                                                                    <Button className="btn-block" disabled={!signed || loader} onClick={handleSuscripcion} id="btnFinalizarPreRegistro" type="button" variant="success">
                                                                        {signed ? <>Finalizar {loader ? <FontAwesomeIcon icon={faSpinner} spin /> : null}</> : "Firma tu contrato para finalizar"}
                                                                    </Button>
                                                                    <p>Se generará tu contrato de suscripción y podrás iniciar sesión con tus credenciales actuales</p>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row></>
                                            ) : null} */}
                                        </Form>
                                    </>
                                )}

                            </Col>
                        </Row>



                    </Container>
                </div>
            </Animated>


        </>
    )
}

export default FormularioSuscripcion